import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import logo from './logo.svg';

import Navbar from './Navbar';
import SuperMarket from './SuperMarket';
import Market from './Market';
import MarketOL from './MarketOL';
import MarketOLT from './MarketOLT';
import MarketOptions from './MarketOptions';
import ToyStore from './ToyStore';
import BillGenerator from './BillGenerator';
import MarketOL3 from './MarketOL3';
import MarketOptions1 from './MarketOptions1';

import AboutUs from './AboutUs';
import HomePage from './HomePage';
import TechStore from './TechStore';
import ElectricalAppliances from './ElectricalAppliances';
import BeautyCare from './BeautyCare';
import Boutique from './Boutique';
import Stationary from './Stationary';
import Services from './Services';
import Hotel from './Hotel';
import SimpleInvoice from './SimpleInvoice';
import PrivacyPolicy from './PrivacyPolicy';
import DateDifference from './DateDifference';
import RecordTime from './RecordTime';


function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} /> 
          <Route path="/SuperMarket" element={<SuperMarket />} />
          <Route path="/TechStore" element={<TechStore />} />
           <Route path="/ElectricalApplicances" element={<ElectricalAppliances />} />
           <Route path="/BeautyCare" element={<BeautyCare />} />
            <Route path="/Boutique" element={<Boutique />} />
            <Route path="/Stationary" element={<Stationary />} />
            <Route path="/Services" element={<Services />} />
              <Route path="/Hotel" element={<Hotel />} />
              <Route path="/SimpleInvoice" element={<SimpleInvoice />} />
          {/* <Route path="/Market" element={<Market />} />
          <Route path="/MarketOL" element={<MarketOL />} />
          <Route path="/MarketOLT" element={<MarketOLT />} />
          <Route path="/MarketOptions" element={<MarketOptions />} />
          <Route path="/ToyStore" element={<ToyStore />} />
          <Route path="/BillGenerator" element={<BillGenerator />} />
          <Route path="/MarketOL3" element={<MarketOL3 />} />
          <Route path="/MarketOptions1" element={<MarketOptions1 />} /> */}
                        <Route path="/DateDifference" element={<DateDifference />} />
                        <Route path="/RecordTime" element={<RecordTime />} />


          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
